import { useStrings } from "@1js/localization-components";
import {
  Column,
  displayCategoryToIcon,
  Row,
  type CollectionFilterKeyType,
  type PromptCategory,
} from "@1js/pl-card-components";
import {
  Button,
  CompoundButton,
  makeStyles,
  tokens,
} from "@fluentui/react-components";
import { ChevronDownRegular, ChevronUpRegular } from "@fluentui/react-icons";
import React from "react";
import { SeeLessButton, SeeMoreButton } from "../MetaOs/MetaOSV2.web.string";

const promptCategoryStyles = makeStyles({
  main: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXXL,
    marginTop: tokens.spacingVerticalXL,
    width: "100%",
    paddingTop: "84px",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    rowGap: "16px",
    marginLeft: "0px",
    marginRight: "0px",
  },
  column: {
    padding: 0,
    height: "min-content",
    paddingLeft: "6px",
    paddingRight: "6px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  cardWrapper: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  title: {
    margin: "0px 6px",
  },
  btnContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  btn: {
    border: "none",
  },
  icon: {},
});

export type BrowseByGridContainerProps = {
  type: CollectionFilterKeyType;
  items: string[];
  title: string;
  onBrowseByClick(filterKey: CollectionFilterKeyType, item: string): void;
};

export const BrowseByGridContainer: React.FC<BrowseByGridContainerProps> = ({
  items,
  title,
  type,
  onBrowseByClick,
}) => {
  const styles = promptCategoryStyles();
  const [isExpanded, setIsExpanded] = React.useState(false);
  const localizations = useStrings({
    SeeMoreButton,
    SeeLessButton,
  });

  return (
    <div className={styles.main}>
      <h2 className={styles.title}>{title}</h2>
      <Row className={styles.container}>
        {items.slice(0, isExpanded ? items.length : 4).map((item, index) => (
          <Column size={3} key={index} className={styles.column}>
            <CompoundButton
              as={"button"}
              title={item}
              aria-label={item}
              data-testid={item}
              onClick={() => onBrowseByClick(type, item)}
              icon={displayCategoryToIcon(
                item as PromptCategory,
                {
                  icon: "",
                },
                true
              )}
              size={"medium"}
              className={styles.cardWrapper}
            >
              {item}
            </CompoundButton>
          </Column>
        ))}
      </Row>
      <div className={styles.btnContainer}>
        <Button
          className={styles.btn}
          onClick={() => setIsExpanded(!isExpanded)}
          icon={isExpanded ? <ChevronUpRegular /> : <ChevronDownRegular />}
          iconPosition={"after"}
        >
          {isExpanded
            ? localizations.SeeLessButton()
            : localizations.SeeMoreButton()}
        </Button>
      </div>
    </div>
  );
};

export default BrowseByGridContainer;
